import { useMutation } from '@tanstack/react-query';
import { recordFields } from '../shared/content.ts';
import type { ContentObject } from '../shared/content.ts';
import { api, invalidateSite, unwrap } from './api.ts';
import { useDraft } from './use-draft.ts';

export function useContentDraft(siteId: string, object: Extract<ContentObject, { kind: 'Settings' }>) {
  const draft = useDraft(recordFields(object), object.versionId);
  const save = useMutation({
    mutationFn: async () =>
      unwrap(
        await api.PATCH('/api/sites/{siteId}/settings', {
          params: { path: { siteId } },
          headers: { 'Content-Type': 'application/json-patch+json' },
          body: draft.captureJsonPatch(),
        }),
      ),
    onSuccess: async (result) => {
      draft.reset(recordFields(result), result.versionId);
      await invalidateSite(siteId);
    },
  });
  return { ...draft, save };
}
